<script setup lang="ts">
import { BellIcon, CalendarClockIcon } from '@lucide/vue';
import { isDashboardSubscriptionsEnabled } from '@/utilities/FeatureFlags';

const tabs = [
  { to: '/notifications/preferences', label: 'Notification preferences', icon: BellIcon },
  { to: '/notifications/subscriptions', label: 'Dashboard subscriptions', icon: CalendarClockIcon },
];
</script>

<template>
  <nav
    v-if="isDashboardSubscriptionsEnabled()"
    role="tablist"
    class="tabs-border mt-2 tabs w-full justify-center px-4"
    data-testid="notification-settings-tabs">
    <router-link
      v-for="tab in tabs"
      :key="tab.to"
      :to="tab.to"
      role="tab"
      class="tab gap-1.5 font-medium"
      active-class="tab-active">
      <component
        :is="tab.icon"
        :size="16" />
      {{ tab.label }}
    </router-link>
  </nav>
</template>
